import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-wip',
  templateUrl: './wip.component.html',
  styleUrls: ['./wip.component.scss'],
  standalone: false,
})
export class WorkInProgressComponent {
  // Constructor
  constructor(private router: Router) {}
  // Variables
  @Input() public inputData: any;

  /* ----------------------------------------------------------------------------------------------------------- */
  /* ---------------------------------------- WIP FUNCTIONS START ---------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------------- */

  public giveFeedback() {
    this.router.navigate(['psynote/help-contact']);
  }

  /* ----------------------------------------------------------------------------------------------------------- */
  /* ---------------------------------------- WIP FUNCTIONS END ------------------------------------------------ */
  /* ----------------------------------------------------------------------------------------------------------- */
}
